import {Output, EventEmitter, Directive } from '@angular/core';
const fieldToFormName = str => str.replace(/[\.]/g, '_');
const formNameToField = str => str.replace(/[_]/g, '.');

export interface A2FilterModel {
  [key: string] :Array<KeyFilter>
}
export interface KeyFilter {
  value: any;
  op: '===' | '!==';
  key: string;
}

@Directive()
export class A2filter {
  @Output() readonly filterChange: EventEmitter<any> = new EventEmitter<any>();
  public filters:A2FilterModel={};
  form;
  //brand;
  constructor(form){
    this.form = form;
    // Según los campos del formulario de filtro armamos el arreglo de filtros
    // Esto puede funcionar por ahora pero posteriormente podremos pasar excepciones
    Object.keys(form.controls).forEach(key => {
      this.filters[key]=[];
      // console.log('key', key);
    });
    // console.log(this.filters);

  }
  add(key, _op?){
    // se agrega al arreglo de filtros objetos con {value, op}
    // donde op es el comparador
    const op = _op ? _op : '===';
    const k = formNameToField(key)
    this.filters[key].push({value:this.form.value[key], op:op, key:k});
    this.form.patchValue({[key]:''});
    this.filterChange.emit({filterName: key, filters: this.filters});
  }
  remove(event){
    const item = event.item;
    const key = event.key;
    this.filters[key].splice(item, 1);
    this.filterChange.emit({filterName: key, filters: this.filters});
  }
  set(key, _op?){
    const op = _op ? _op : '===';
    if (Array.isArray(key)) this._setM(key, op);
    else{
      const k = formNameToField(key)
      this.filters[key]=[({value:this.form.value[key], op:op, key:k})];
      this.form.patchValue({[key]:''});
      this.filterChange.emit({filterName: key, filters: this.filters});
    }
  }
  private _setM(keys, _op?){
    keys.forEach(key => {
      const k = formNameToField(key);
      this.filters[key]=[({value:this.form.value[key], op:_op, key:k})];
      this.form.patchValue({[key]:''});
    });
    console.log("Er filtro:", this.filters);
    this.filterChange.emit({filterName: keys, filters: this.filters});
  }

  unset(key){
    if (Array.isArray(key)) this._unsetM(key);
    else{
      this.filters[key]=[];
      this.form.patchValue({[key]:''});
      this.filterChange.emit({filterName: key, filters: this.filters});
    }
  }

  private _unsetM(keys){
    keys.forEach(key => {
      this.filters[key]=[];
      this.form.patchValue({[key]:''});
    });
    this.filterChange.emit({filterName: keys, filters: this.filters});
  }

  refresh(){
    this.filterChange.emit({filters: this.filters});
  }

}
